import { domReady } from 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Helper';
import ScrollEffect from './ScrollEffect';
import initSwiper from './InitSwiper';

function init() {
    initSwiper();
    ScrollEffect({
        selector: '.swiper-type--image',
        blur: false,
        headline: true
    });
}

try {
    _gg.onReady.Swiper = init;
} catch (error) {
    domReady(init);
}
